import { render, staticRenderFns } from "./GruposClientesCRUD.vue?vue&type=template&id=5fc30678"
import script from "./GruposClientesCRUD.vue?vue&type=script&lang=js"
export * from "./GruposClientesCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports